import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { loadFundraisingProjectGuard } from '@/guards/load-fundraising-project.guard';
import { setTitle } from '@/services/utils/a11y-title.service';
import { checkAndLoadFundraisingAssets } from '@/modules/fundraising-assets/services/session/fundraising-assets.service';
import { getFundraisingProjectPageTitle } from '@/services/session/details-display.service';
import { syncQueryParamsToStore } from '@/services/session/search-query-params-sync.service';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Search',
    component: () =>
      import(/* webpackChunkName: "search" */ '../views/Search.vue'),
    beforeEnter: async (to, from, next) => {
      syncQueryParamsToStore(to);
      next();
    },
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: () =>
      import(/* webpackChunkName: "detail" */ '../views/Detail.vue'),
    beforeEnter: async (to, from, next) => {
      const hasDetail = await loadFundraisingProjectGuard(
        to.params.id.toString()
      );
      if (!hasDetail) {
        next({ name: 'Detail Not Found' });
      } else {
        setTitle(getFundraisingProjectPageTitle());
        next();
      }
    },
  },
  {
    path: '/detail/not-found',
    name: 'Detail Not Found',
    component: () =>
      import(
        /* webpackChunkName: "detail-not-found" */ '../views/DetailNotFound.vue'
      ),
  },
  {
    path: '/:pathMatch(.*)',
    name: '404 Not Found',
    component: () =>
      import(
        /* webpackChunkName: "404-not-found" */ '../views/404NotFound.vue'
      ),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async () => {
  // Load Fundraising Assets to Store
  await checkAndLoadFundraisingAssets();
});

export default router;
